module.exports = __webpack_public_path__ + "static/montlobre_purple-8c30b916c7a6dc9ac30f3383b49e95e0.png";